import { render, staticRenderFns } from "./WebshopProductDisplay.vue?vue&type=template&id=b05856b2&"
import script from "./WebshopProductDisplay.vue?vue&type=script&lang=js&"
export * from "./WebshopProductDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WebshopProductDisplay.vue?vue&type=style&index=0&id=b05856b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardText,VContainer,VImg})
